export default {
  computed: {
    /**
     * Enables sorting of items in Bootstrap-vue table component.
     */
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    }
  }
}
